import Team5 from './Team5'
export default Team5
